import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../constants";

export interface HomepageBlock5Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock5 = forwardRef<HTMLDivElement, HomepageBlock5Props>(
  ({ content, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-grid md:wb-grid-cols-2 md:wb-gap-[1.88rem] lg:wb-grid-cols-4">
                {content}
              </BlockSection.NestedBlock>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock5.displayName = "HomepageBlock5";
